export default [
  {
    value: '020:001',
    label:
      'Acquisition Management (Environmental Programs & Management, Superfund, Leaking Underground Storage Tanks)',
    sublabel:
      "Resources in this program support activities related to the management of contract/acquisition at Headquarters, Regions, Research Triangle Park, Cincinnati, and Las Vegas. This program focuses on maintaining a level of integrity in the management of EPA's procurement activities, and fostering relationships with State and Local governments to support the implementation of environmental programs."
  },
  {
    value: '020:002',
    label: 'Administrative Law (Environmental Programs & Management)',
    sublabel:
      "This program supports EPA's Administrative Law Judges (ALJ) and the Environmental Appeals Board (EAB) or the Board. The ALJ preside in hearings and issue initial decisions in cases initiated by EPA's enforcement program concerning environmental violations. "
  },
  {
    value: '020:003',
    label:
      'Alternative Dispute Resolution (Environmental Programs & Management, Superfund)',
    sublabel:
      'This program provides Alternative Dispute Resolution services to EPA Headquarters and Regional Offices, and external stakeholders to assist in developing effective ways to anticipate, prevent, and resolve disputes, and make neutral third parties more readily available for those purposes.'
  },
  {
    value: '020:004',
    label:
      'Audits, Evaluations, and Investigations (Inspector General, Superfund)',
    sublabel:
      'This program uses sophisticated analytical tools, methodologies, and specialized skills to determine the extent to which the desired results and benefits envisioned by the Administration and Congress are being achieved. Investigations focus on detection and prosecution of financial fraud, laboratory fraud, and cyber crime.'
  },
  {
    value: '020:005',
    label: 'Beach / Fish Programs (Environmental Programs & Management)',
    sublabel:
      'This program provides sound science, guidance, technical assistance and nationwide information to state, Tribal, and federal agencies on the human health risks associated with eating locally caught fish/shellfish or wildlife with excessive levels of contaminants. It provides guidance, technical assistance and nationwide information to support state, Tribal, and local government beach monitoring and notification programs.'
  },
  {
    value: '020:006',
    label: 'Brownfields (Environmental Programs & Management)',
    sublabel:
      'This program is designed to empower states, Tribes, local communities, and other stakeholders in economic redevelopment to work together to prevent, assess, safely cleanup, and reuse Brownfields. This program involves oversight from a Federal level. This program comprises the administrative component of the Brownfields program, supporting human resources, travel, training, technical assistance, and research activities. The program also includes growth and sustainable design that address Brownfield issues.Brownfields are defined as real properties, the expansion, redevelopment, or reuse, which may be complicated by the presence or potential presence of a hazardous substance, pollutant, or contaminant. The growth activities include: (1) removing barriers and creating incentives for Brownfields redevelopment by changing standards that affect the viability of Brownfields redevelopment; and (2) creating cross-cutting solutions that improve the economic, regulatory, and institutional climate for Brownfields redevelopment.'
  },
  {
    value: '020:007',
    label: 'Brownfields Projects (State & Tribal Assistance Grants)',
    sublabel:
      'This program is authorized by CERCLA section § 104 (k) through a competitive process with a ranking system that includes factors relating to community need, impact on human health and the environment, stimulation or leveraging of other funds, eligibility for funding from other sources, and effective use of existing infrastructure. Brownfields are defined as real properties, the expansion, redevelopment, or reuse of which may be complicated by the presence or potential presence of a hazardous substance, pollutant, or contaminant.'
  },
  {
    value: '020:008',
    label:
      'Categorical Grant: Beaches Protection (State & Tribal Assistance Grants)',
    sublabel:
      'This program, authorized under the Beach Act to support continued development and implementation of coastal and Great Lakes recreational water monitoring and public notification programs. This is a mature program that has been proposed for elimination as the EPA has worked with state, tribal, and territorial governments for over ten years to develop their capacity to implement beach monitoring programs.'
  },
  {
    value: '020:009',
    label: 'Categorical Grant: Brownfields (State & Tribal Assistance Grants)',
    sublabel:
      'This program, authorized under CERCLA §129(a) provides funding assistance to empower states and Tribes to work to prevent, assess, safely cleanup, and reuse Brownfields. Brownfields are defined as real properties, the expansion, redevelopment, or reuse of which may be complicated by the presence or potential presence of a hazardous substance, pollutant, or contaminant.'
  },
  {
    value: '020:010',
    label:
      'Categorical Grant: Environmental Information (State & Tribal Assistance Grants)',
    sublabel:
      'This program advances the Exchange Network by providing funding to states, Tribes, and territories to develop and deploy technologies based on Exchange Network specifications and standards to report and share environmental data.'
  },
  {
    value: '020:011',
    label: 'Categorical Grant: Evaluation Grants',
    sublabel:
      'The Evidence-Based Enforcement and Compliance grants program will assist states in developing and implementing innovative measures for assessing the performance of enforcement and compliance programs. It also will help the states design and implement innovative enforcement tools or approaches and measure the impact of such approaches. These grants will build capacity for collecting, using, and sharing enforcement and compliance data, and for determining the most efficient and effective practices for improving compliance. Evaluation of new approaches will help to determine those most promising for potential expansion and replication.'
  },
  {
    value: '020:012',
    label:
      'Categorical Grant: Hazardous Waste Financial Assistance (State & Tribal Assistance Grants)',
    sublabel:
      'The Resource Conservation and Recovery Act (RCRA) authorizes and the directs the EPA to assist state programs through the Hazardous Waste Financial Assistance Grants program. These state grants provide resources for authorized states to implement the hazardous waste management program, and amount to well over half of the total resources available in state program budgets.'
  },
  {
    value: '020:013',
    label: 'Categorical Grant: Lead (State & Tribal Assistance Grants)',
    sublabel:
      'This program provides grants to states and Tribes for lead-based paint training and certification. Direct implementation by EPA in locations without authorized programs.'
  },
  {
    value: '020:014',
    label:
      'Categorical Grant: Nonpoint Source (Sec. 319) (State & Tribal Assistance Grants)',
    sublabel:
      'This program provides grants to states and Indian Tribes in the implementation of approved elements of Nonpoint Source management programs. '
  },
  {
    value: '020:015',
    label:
      'Categorical Grant: Pesticides Enforcement (State & Tribal Assistance Grants)',
    sublabel:
      'The Pesticide Enforcement grants to states and Tribes ensure pesticide product and user compliance with provisions of the Federal Insecticide, Fungicide and Rodenticide Act (FIFRA).'
  },
  {
    value: '020:016',
    label:
      'Categorical Grant: Pesticides Program Implementation (State & Tribal Assistance Grants)',
    sublabel:
      'This program provides grants to states and tribes to ensure the safer use of pesticides, including worker protection, certification and training of pesticide applicators, protection of endangered species, tribal pesticide programs, integrated pest management and environmental stewardship.'
  },
  {
    value: '020:017',
    label:
      'Categorical Grant: Pollution Control (Sec. 106) (State & Tribal Assistance Grants)',
    sublabel:
      "This program provides grants to states, tribes, and interstate agencies to support key programs for the prevention, reduction and elimination of surface and ground water pollution from point and non-point sources for enhancing the ecological health of the Nation's waters."
  },
  {
    value: '020:018',
    label:
      'Categorical Grant: Pollution Prevention (State & Tribal Assistance Grants)',
    sublabel:
      'This program provides grants to states and tribes to test innovative pollution prevention (P2) approaches and to provide P2 technical assistance to companies.'
  },
  {
    value: '020:019',
    label:
      'Categorical Grant: Public Water System Supervision (PWSS) (State & Tribal Assistance Grants)',
    sublabel:
      "This program provides grants to implement and enforce National Primary Drinking Water Regulations to ensure the safety of the nation's drinking water resources and to protect public health."
  },
  {
    value: '020:020',
    label: 'Categorical Grant: Radon (State & Tribal Assistance Grants)',
    sublabel:
      'The program includes funding for state radon programs to support radon outreach, education, testing, mitigation and radon resistant new construction, and other activities to reduce public health risks from radoninduced lung cancer. This is a mature program that has been proposed for elimination. Local and state governments can now carry out the goals of this mature federal program.'
  },
  {
    value: '020:021',
    label:
      'Categorical Grant: State and Local Air Quality Management (State & Tribal Assistance Grants)',
    sublabel:
      'This program includes funding for state and local air pollution control agencies designated by Governors. Under CAA Section 105 Grants, state and local air pollution control agencies may develop and implement continuing programs for the prevention and control of air pollution or implementation of national primary and secondary ambient air standards.'
  },
  {
    value: '020:022',
    label:
      'Categorical Grant: Toxics Substances Compliance (State & Tribal Assistance Grants)',
    sublabel:
      'The EPA/State and Tribal Assistance Grants (State & Tribal Assistance Grants) program builds environmental partnerships with states and tribes to help build state capacity and strengthen their ability to address environmental and public health threats from toxic substances such as Polychlorinated Biphenyls (PCBs), asbestos, and lead-based paint rules. The State & Tribal Assistance Grants grants are used to assist in the implementation of compliance and enforcement provisions of TSCA.'
  },
  {
    value: '020:023',
    label:
      'Categorical Grant: Tribal Air Quality Management (State & Tribal Assistance Grants)',
    sublabel:
      'This program includes funding for Tribal air pollution control agencies and/or Tribes. Through CAA Section 105 Grants, Tribes may develop and implement programs for the prevention and control of air pollution or implementation of continuing national primary and secondary ambient air standards.'
  },
  {
    value: '020:024',
    label:
      'Categorical Grant: Tribal General Assistance Program (State & Tribal Assistance Grants)',
    sublabel:
      'This program provides general assistance grants to elIgible Tribal governments and intertribal consortia for planning, developing, and establishing environmental programs in Indian Country.'
  },
  {
    value: '020:025',
    label:
      'Categorical Grant: Underground Injection Control (UIC) (State & Tribal Assistance Grants)',
    sublabel:
      'This program provides financial assistance, in the form of grants, to states that have primary enforcement authority (primacy) to implement and maintain UIC programs.'
  },
  {
    value: '020:026',
    label:
      'Categorical Grant: Underground Storage Tanks (State & Tribal Assistance Grants)',
    sublabel:
      'This program provides grants to states to support leak prevention activities and detection programs. This program approves technologies to detect leaks from tanks, ensures that tank owners and operators are complying with requirements, and ensures equipment compatibility.'
  },
  {
    value: '020:027',
    label:
      'Categorical Grant: Wetlands Program Development (State & Tribal Assistance Grants)',
    sublabel:
      'The program provides grants to develop new or refined existing state and Tribal wetland programs in one or more of the following areas: monitoring and assessment, voluntary restoration and protection.'
  },
  {
    value: '020:028',
    label:
      'Central Planning, Budgeting, and Finance (Environmental Programs & Management, Superfund, Leaking Underground Storage Tanks)',
    sublabel:
      'This program manages integrated planning, budgeting, financial management, and accountability processes and systems to ensure effective stewardship of resources which meets the statutory requirements of the Government Performance and Results Act, the Chief Financial Officer Act, and related legislation.'
  },
  {
    value: '020:029',
    label:
      'Children and Other Sensitive Populations: Agency Coordination (Environmental Programs & Management)',
    sublabel:
      "This program coordinates and advances protection of children's environmental health through regulatory development, science policy, program implementation, communication and effective results measurement as an explicit part of its mission to protect human health."
  },
  {
    value: '020:030',
    label:
      'Civil Enforcement (Environmental Programs & Management, Leaking Underground Storage Tanks, Oil Spill Response)',
    sublabel:
      'This program focuses on the protection of human health and the environment by targeting enforcement actions according to the degree of health and environmental impacts due to noncompliance with federal environmental statutes and regulations. These activities include data gathering and analysis of information to determine high priority noncompliance or environmental problems on which to focus federal, state, Tribal or local attention; inspections; enforcement or compliance assistance.'
  },
  {
    value: '020:031',
    label:
      'Civil Rights / Title VI Compliance (Environmental Programs & Management)',
    sublabel:
      "This program includes the following activities: Intake and processing of Title VI complaints of discrimination from the public about EPA's financial assistance recipients, complaint adjudication, and civil rights compliance reviews; intake and processing of Title VII complaints of discrimination from Agency employees and applicants for employment, and complaint adjudication; implementation of processes and programs in support of reasonable accommodation; and affirmative employment and diversity program planning and implementation."
  },
  {
    value: '020:032',
    label:
      'Clean Air Allowance Trading Programs (Science & Technology, Environmental Programs & Management)',
    sublabel:
      'This program includes development, implementation, and evaluation of federally administered programs for the trading of emissions allowances.'
  },
  {
    value: '020:033',
    label:
      'Climate Protection Program (Science & Technology, Environmental Programs & Management)',
    sublabel:
      'This program includes voluntary domestic and international programs that address greenhouse gases (GHG), and technology to address climate change issues.'
  },
  {
    value: '020:034',
    label:
      'Compliance Monitoring (Environmental Programs & Management, Superfund, Oil Spill Response)',
    sublabel:
      'This program includes all activities to determine whether regulated entities are in compliance with environmental laws and regulations, as well as enforcement agreements activities can include, but are not limited to, permit, file and report reviews; sampling and gathering data; analysis and use of information to determine high priority noncompliance or environmental problems on which to focus federal, state, tribal or local attention; inspections and investigations.'
  },
  {
    value: '020:035',
    label:
      'Congressional, Intergovernmental, External Relations (Environmental Programs & Management)',
    sublabel:
      "The Congressional, Intergovernmental and External Relations program provides vital executive and logistical support for the EPA's Administrator."
  },
  {
    value: '020:036',
    label:
      'Criminal Enforcement (Environmental Programs & Management, Superfund)',
    sublabel:
      'The Criminal Enforcement program seeks to identify, apprehend, and assist prosecutors in succesfully convicting those who are responsible for the most significant and egregious intentional violations of environmental laws.'
  },
  {
    value: '020:037',
    label:
      'Diesel Emissions Reduction Grant Program (State & Tribal Assistance Grants)',
    sublabel:
      'The Diesel Emissions Reduction Act (DERA) Grant Program provides immediate, cost-effective emission reductions from existing diesel engines through engine retrofits, rebuilds, and replacements; switching to cleaner fuels; idling reduction strategies; and other clean diesel strategies.'
  },
  {
    value: '020:038',
    label:
      'Drinking Water Programs (Science & Technology, Environmental Programs & Management)',
    sublabel:
      'This program comprises the multiple-barrier approach to protecting public health from unsafe drinking water. Under this approach, the Agency protects public health through: source water assessment and protection programs; promulgation of new or revised, scientifically sound and riskbased National Primary Drinking Water Regulations (NPDWRs).'
  },
  {
    value: '020:039',
    label: 'Endocrine Disruptors (Environmental Programs & Management)',
    sublabel:
      'This program develops and validates scientific test methods from which a battery of tests will be selected and used for the routine, ongoing evaluation of pesticides and other chemicals to determine their potential for adverse health or environmental effects by interfering with normal endocrine system function.'
  },
  {
    value: '020:040',
    label: 'Environmental Education (Environmental Programs & Management)',
    sublabel:
      'This program has ensured that Environmental Education, using a sciencebased approach and effective education practices, has been used as a tool to promote the protection of human health and the environment, and has encouraged student academic achievement. This is part of the mature programs that are being proposed for elimination. The Agency will focus on integrating environmental education activities into existing Agency programs.'
  },
  {
    value: '020:042',
    label: 'Exchange Network (Environmental Programs & Management, Superfund)',
    sublabel:
      'The Exchange Network program supports the sharing and integration of state, Tribal, and federal government environmental data and information.'
  },
  {
    value: '020:043',
    label:
      'Facilities Infrastructure and Operations (Science & Technology, Environmental Programs & Management, Buildings & Facilities, Superfund, Leaking Underground Storage Tanks, Oil Spill Response)',
    sublabel:
      'This program directs management activities and support services in many centralized administrative areas such as health and safety, environmental compliance, occupational health, medical monitoring, fitness/wellness and safety, and environmental management and protection service functions at EPA.'
  },
  {
    value: '020:044',
    label:
      'Federal Stationary Source Regulations (Environmental Programs & Management)',
    sublabel:
      'This program includes activities related to the development of New Source Performance Standards that address Greenhouse Gases (GHGs), and associated national guidance and outreach information.'
  },
  {
    value: '020:045',
    label:
      'Federal Support for Air Quality Management (Science & Technology, Environmental Programs & Management)',
    sublabel:
      'This program includes both EPA Headquarters and Regional Federal support to state, tribal, and local air pollution control agencies for the implementation and evaluation of programs related to permitting sources of Greenhouse Gases (GHGs) under the Prevention of Significant Deterioration and Title V Greenhouse Gas Tailoring Rule.'
  },
  {
    value: '020:046',
    label:
      'Federal Vehicle and Fuels Standards and Certification (Science & Technology',
    sublabel:
      'The Federal Vehicle and Fuels Standards and Certification program develops, implements, and ensures compliance with national standards to reduce mobile source related air pollution from light-duty cars and trucks, heavy-duty trucks and buses, nonroad engines and vehicles, and from the fuels that power these engines. The program also evaluates emission control technology and provides state, Tribal, and local air quality managers and transportation planners with access to information on transportation programs and incentive-based programs.'
  },
  {
    value: '020:047',
    label:
      'Financial Assistance Grants / IAG Management (Environmental Programs & Management, Superfund)',
    sublabel:
      'This program supports activities related to the management of Financial Assistance Grants/IAG and suspension and debarment at Headquarters, Regions, Research Triangle Park, Cincinnati, and Las Vegas.'
  },
  {
    value: '020:048',
    label: 'Forensics Support (Science & Technology, Superfund)',
    sublabel:
      'The Forensics program provides specialized support for the nation’s most complex civil and criminal enforcement cases, and technical expertise for non-routine Agency compliance efforts.'
  },
  {
    value: '020:049',
    label:
      'Geographic Program: Chesapeake Bay (Environmental Programs & Management)',
    sublabel:
      "The Chesapeake Bay Program includes the States of Delaware, Maryland, New York, Virginia, Pennsylvania, West Virginia, the District of Columbia, the Chesapeake Bay Commission, EPA and other federal partners working together to protect and restore the Bay's ecosystem."
  },
  {
    value: '020:050',
    label:
      'Geographic Program: Gulf of Mexico (Environmental Programs & Management)',
    sublabel:
      'This program consists of a partnership of the five Gulf states, Gulf coastal communities, citizens, nongovernmental organizations, and federal agencies working together to initiate cooperative actions by public and private organizations to achieve specific environmental results.'
  },
  {
    value: '020:051',
    label:
      'Geographic Program: Lake Champlain (Environmental Programs & Management)',
    sublabel:
      'This program focuses on the creation of a comprehensive pollution prevention, control, and restoration plan for protecting the future of the Lake Champlain Basin and implement the plan.'
  },
  {
    value: '020:052',
    label:
      'Geographic Program: Long Island Sound (Environmental Programs & Management)',
    sublabel:
      'This program implements the Comprehensive Conservation and Management Plan for the Long Island Sound National Estuary Program, through support for the Long Island Sound Office.'
  },
  {
    value: '020:053',
    label: 'Geographic Program: Other (Environmental Programs & Management)',
    sublabel:
      'This program works to develop and implement community-based approaches to mitigate diffuse sources of pollution and cumulative risk for geographic areas. EPA targets efforts to protect and restore various communities and ecosystems impacted by environmental problems. The Agency also fosters community efforts to build consensus and mobilize local resources to target highest risks.'
  },
  {
    value: '020:054',
    label:
      'Geographic Program: Puget Sound (Environmental Programs & Management)',
    sublabel:
      "The Puget Sound program works to protect and restore the Puget Sound which has been designated as an estuary of national significance under the Clean Water Act National Estuary Program (NEP). EPA’s efforts are focused on high priority environmental activities consistent with the State of Washington's 2020 Puget Sound Action Agenda."
  },
  {
    value: '020:055',
    label:
      'Geographic Program: San Francisco Bay (Environmental Programs & Management)',
    sublabel:
      'The San Francisco Bay-Delta Estuary program is aimed at protecting and restoring water quality and ecological health of the estuary through partnerships, interagency coordination, and project grants.'
  },
  {
    value: '020:056',
    label:
      'Geographic Program: South Florida (Environmental Programs & Management)',
    sublabel:
      'The South Florida program leads special initiatives and planning activities in the South Florida region, which includes the Everglades and Florida Keys coral reef ecosystem.'
  },
  {
    value: '020:057',
    label: 'Great Lakes Restoration (Environmental Programs & Management)',
    sublabel:
      "The Great Lakes (GL) Program nworks to restore and maintain the chemical, physical, and biological integrity of the Great Lakes Basin Ecosystem as required by the Great Lakes Water Quality Agreement and the Clean Water Act. EPA leads 16 federal agencies in development and implementation of a Great Lake Restoration Initiative to achieve that goal, including overseeing international commitments in the Great Lake Water Quality Agreement. The Great Lakes Restoration Initiative funding is provided through EPA's Great Lake National Program Office."
  },
  {
    value: '020:058',
    label:
      'Homeland Security: Communication and Information (Environmental Programs & Management)',
    sublabel:
      'This program ensures implementation of EPA’s Homeland Security Strategy and use of an Agency-wide Homeland Security Collaborative Network. This program also designs, develops, deploys and maintains a secure and stable infrastructure to support the Agency’s critical communications and data-transfer demands in the event of a national or local disaster, and supports a dispersed workforce in the event of a largescale catastrophic incident, a Continuity of Operations (COOP) Plan, or a pandemic situation.'
  },
  {
    value: '020:059',
    label:
      'Homeland Security: Critical Infrastructure Protection (Science & Technology, Environmental Programs & Management)',
    sublabel:
      "This program involves EPA activities that help protect the nation's critical public infrastructure from terrorist threats. EPA is committed to assessing and reducing vulnerabilities and strengthening detection and response capabilities for critical infrastructures."
  },
  {
    value: '020:060',
    label:
      'Homeland Security: Preparedness, Response, and Recovery (Science & Technology, Environmental Programs & Management, Superfund)',
    sublabel:
      'This program involves activities that help the public prepare, respond, and recover from terrorist and CBRN incidents.'
  },
  {
    value: '020:061',
    label:
      'Homeland Security: Protection of EPA Personnel and Infrastructure (Science & Technology, Environmental Programs & Management, Buildings & Facilities, Superfund)',
    sublabel:
      "This program involves activities to ensure EPA's physical structures and assets are secure and operational. This involves safeguarding EPA's staff, ensuring the continuity of EPA's operations, and protecting the operational capability of EPA's vital infrastructure assets."
  },
  {
    value: '020:062',
    label: 'Human Health Risk Assessment (Science & Technology, Superfund)',
    sublabel:
      "The EPA's Human Health Risk Assessment (HHRA) research program generates health assessments and scientific products that are used extensively by the EPA Program and Regional offices, and other parties to estimate the potential risk to public health from exposure to environmental contaminants."
  },
  {
    value: '020:063',
    label:
      'Human Resources Management (Environmental Programs & Management, Superfund)',
    sublabel:
      'This program performs functions in all aspects of human resources programs, organizational development, and management activities including support to Agency-wide and interagency councils and committees and serving as EPA’s liaison on interagency management improvement initiatives.'
  },
  {
    value: '020:064',
    label:
      'Indoor Air: Radon Program (Science & Technology, Environmental Programs & Management)',
    sublabel:
      'This program includes voluntary national, regional, state, and Tribal programs and activities that address radon primarily in homes as well as indoor air laboratory related infrastructure expenses.'
  },
  {
    value: '020:065',
    label:
      'Information Security (Environmental Programs & Management, Superfund)',
    sublabel:
      "This program protects the confidentiality, availability, and integrity of the Agency's information assets. It establishes a risk-based cyber security program utilizing a defense-in-depth approach that includes partnering with other Federal agencies and the states. "
  },
  {
    value: '020:066',
    label:
      'Infrastructure Assistance: Alaska Native Villages (State & Tribal Assistance Grants)',
    sublabel:
      'This program supports the wastewater and drinking water infrastructure projects in Alaska Native and rural villages.'
  },
  {
    value: '020:067',
    label:
      'Infrastructure Assistance: Clean Water SRF (State & Tribal Assistance Grants)',
    sublabel:
      'This program provides Federal funds to the states and Puerto Rico to capitalize the revolving loan fund. The program also includes a provision for Indian set-aside grant funds.'
  },
  {
    value: '020:068',
    label:
      'Infrastructure Assistance: Drinking Water SRF (State & Tribal Assistance Grants)',
    sublabel:
      'This program provides Federal funds to the states and Puerto Rico to capitalize their revolving funds and is designed to help public water systems finance the costs of infrastructure improvements needed to achieve or maintain compliance with the Safe Drinking Water Act (SDWA) requirements and to protect public health. Resources may also fund Interagency Agreements (IAs) to other Federal agencies, such as the Indian health service in HHS, that provide safe drinking water activities in support of the Tribes.'
  },
  {
    value: '020:069',
    label:
      'Infrastructure Assistance: Mexico Border (State & Tribal Assistance Grants)',
    sublabel:
      'This program includes Headquarters and Regional Federal support to state, tribal, and local air pollution control agencies for the following: modeling, inventories, monitoring, assessments, strategy and program development; community based toxics programs; voluntary programs including those that reduce inhalation risk and those that reduce deposition to water bodies and ecosystems; international cooperation to reduce trans-boundary and intercontinental air toxic pollution; National Toxics Inventory (NTI) development and updates; Great Waters; and Persistent Bio-accumulative Toxics (PBT) activities. Also includes training for air pollution professionals. In addition, includes activities for implementation of Maximum Achievable Control Technology (MACT) standards and the National Air Toxics Assessment (NATA).'
  },
  {
    value: '020:070',
    label:
      'Integrated Environmental Strategies (Environmental Programs & Management)',
    sublabel:
      "This program supports the Agency's smart growth and sustainable design work, as well as strategic environmental management activities that address cross-cutting and emerging policy issues."
  },
  {
    value: '020:071',
    label:
      'International Sources of Pollution (Environmental Programs & Management)',
    sublabel:
      'This program allows the Agency to work with international partners to address international sources of pollution in order to achieve our domestic environmental objectives. EPA also works with international partners to address the impacts of pollution from the U.S. on other countries and the global environment.'
  },
  {
    value: '020:072',
    label:
      'IT / Data Management (Science & Technology, Environmental Programs & Management, Superfund, Leaking Underground Storage Tanks)',
    sublabel:
      'This program supports the development, collection, management, and analysis of environmental data (to include both point source and ambient data) to manage statutory programs and to support the Agency in strategic planning at the national, program, and regional levels.'
  },
  {
    value: '020:073',
    label:
      'Legal Advice: Environmental Program (Environmental Programs & Management, Superfund)',
    sublabel:
      'This program provides legal representational services, legal counseling, and legal support for all Agency environmental activities by the Office of General Counsel (OGC) and the Offices of Regional Counsel (ORCs).'
  },
  {
    value: '020:074',
    label:
      'Legal Advice: Support Program (Environmental Programs & Management)',
    sublabel:
      'This program provides legal representational services, legal counseling, and legal support for all Agency management and administrative activities by the Office of General Counsel and the Offices of Regional Counsel necessary for the operation of the Agency (i.e., contracts, grants, personnel, information law, ethics, and financial/monetary issues).'
  },
  {
    value: '020:075',
    label:
      'Leaking Underground Storage Tanks / UST (Environmental Programs & Management, Superfund)',
    sublabel:
      'This program provides technical information, forums for information exchanges, and training opportunities to states, Tribes, intertribal consortia and non-governmental organizations to encourage program development and/or implementation of the UST program.'
  },
  {
    value: '020:076',
    label:
      'Leaking Underground Storage Tanks Cooperative Agreements (Leaking Underground Storage Tanks)',
    sublabel:
      'This program is responsible for the oversight, corrective action and related enforcement activities associated with petroleum releases from Underground Storage Tanks (USTs), and for the development and/or implementation of the LUST program in states.'
  },
  {
    value: '020:077',
    label:
      'Leaking Underground Storage Tanks Prevention (Leaking Underground Storage Tanks)',
    sublabel:
      'The Underground Storage Tank (UST) prevention program funds are used to provide resources to States, Tribes, Territories, and intertribal consortia for their UST programs. Major activities focus on inspections, enforcement, development of leak prevention regulations and other program infrastructure.'
  },
  {
    value: '020:078',
    label: 'Marine Pollution (Environmental Programs & Management)',
    sublabel:
      'The Marine Pollution program funds the implementation of regulatory and support activities relating to ocean discharges and related marine ecosystem protection activities.'
  },
  {
    value: '020:079',
    label:
      'National Estuary Program / Coastal Waterways (Environmental Programs & Management)',
    sublabel:
      'This program provides grants and technical assistance to the National Estuary Program and to other coastal watersheds.'
  },
  {
    value: '020:080',
    label:
      'National Environmental Policy Act Implementation (Environmental Programs & Management)',
    sublabel:
      'The NEPA Program provides environmental protection by meeting its statutory obligation to review all environmental impact statements (EISs). The EISs are required for major federal actions which have a significant environmental impact. EPA focuses on adverse environmental impacts of proposed actions and recommends measures to mitigate them.'
  },
  {
    value: '020:081',
    label:
      'Oil Spill Response Spill: Prevention, Preparedness and Response (Oil Spill Response)',
    sublabel:
      'This program includes spill prevention, preparedness, and response activities. The Spill Prevention, Control, and Countermeasures (SPCC) serve to prevent Oil Spill Response spills that have potential to reach navigable waters. Area Planning ensures that EPA and other response organizations have identified resources that need to be protected, and methods to effectively coordinate during response.'
  },
  {
    value: '020:082',
    label:
      'Pesticides: Protect Human Health from Pesticide Risk (Science & Technology, Environmental Programs & Management)',
    sublabel:
      'EPA is charged with protecting people from the health risks that pesticide use can pose; this program reviews pesticide product registrations and sets tolerances for pesticides in food and animal feed.'
  },
  {
    value: '020:083',
    label:
      'Pesticides: Protect the Environment from Pesticide Risk (Science & Technology, Environmental Programs & Management)',
    sublabel:
      'This program seeks to protect the Environment from pesticide risk by conducting risk assessments of pesticide products, determining toxicity and environmental fate of pesticides in the environment and determining any necessary risk mitigation efforts.'
  },
  {
    value: '020:084',
    label:
      'Pesticides: Realize the Value of Pesticide Availability (Science & Technology, Environmental Programs & Management)',
    sublabel:
      'This program carries out reviews of special actions under the Federal Insecticide, Fungicide, and Rodenticide Act, such as addressing special local needs, emergency and crisis exemptions, minor crops, and pest control to ensure that the public health and the socio-economic benefits of pesticide availability and use are achieved.'
  },
  {
    value: '020:085',
    label: 'Pollution Prevention Program (Environmental Programs & Management)',
    sublabel:
      'The program seeks to prevent pollutants from being generated at the source by promoting environmentally sound business practices and the development of safer (green) chemicals, technologies, and processes.'
  },
  {
    value: '020:086',
    label:
      'Radiation: Protection (Environmental Programs & Management, Science & Technology, Superfund)',
    sublabel:
      'This program includes activities for radiation clean up; Federal guidance; Risk Modeling; Waste Isolation Pilot Plant (WIPP); Radiation air toxics; naturally-occurring radioactive material; Radiation waste management; and Radioactive and mixed waste operations and measurements. Also includes radiation lab-related infrastructure expenses.'
  },
  {
    value: '020:087',
    label:
      'Radiation: Response Preparedness (Science & Technology, Environmental Programs & Management)',
    sublabel:
      'This program includes Federal preparedness activities including radiation emergency response team and equipment, training and outreach, and radiological emergency response guidance.'
  },
  {
    value: '020:088',
    label:
      'RCRA: Corrective Action (Environmental Programs & Management, Oil Spill Response)',
    sublabel:
      'This program focuses on the reduction of risks to human health and the environment at contaminated sites through cleanup, assessment, stabilization, or other action and make land available for reuse. This program provides cleanup at industrial facilities.'
  },
  {
    value: '020:089',
    label:
      'RCRA: Waste Management (Environmental Programs & Management, E-Manifest)',
    sublabel:
      "This program supports the proper management of solid and hazardous wastes, from RCRA hazardous waste generators, transporters, and treatment, storage, and disposal (TSD) facilities. EPA's goals include reducing materials and energy use through encouraging product and process redesign and increasing materials and energy recovery from wastes otherwise requiring disposal."
  },
  {
    value: '020:090',
    label:
      'RCRA: Waste Minimization & Recycling (Environmental Programs & Management, E-Manifest)',
    sublabel:
      'This program will encourage the reduction of materials and energy use through product and process redesign, and increase materials and energy recovery from wastes otherwise requiring disposal. EPA will encourage firms to reduce pollution through adoption of more efficient, sustainable and protective policies, practices, materials and technologies.'
  },
  {
    value: '020:091',
    label:
      'Reduce Risks from Indoor Air (Science & Technology, Environmental Programs & Management)',
    sublabel:
      'In this non-regulatory (voluntary) program, the EPA works through partnerships with non-governmental organizations and federal, state, and local partners, as well as professional organizations, to educate and encourage individuals, schools, industry, the health care community, and others to take action to reduce health risks from poor indoor air quality in homes, schools, and other buildings.'
  },
  {
    value: '020:092',
    label:
      'Regional Science and Technology (Environmental Programs & Management)',
    sublabel:
      "The Regional Science and Technology program (RScience & Technology) activities support all of the Agency's national programs (including but not limited to the Agency’s water, air, Superfund, and enforcement programs) and strategic goals, by supplying laboratory analysis, field monitoring and sampling, and building Tribal capacity for environmental monitoring and assessment."
  },
  {
    value: '020:093',
    label:
      'Regulatory/Economic-Management and Analysis (Environmental Programs & Management)',
    sublabel:
      "The Regulatory, Economic, Management and Analysis program assesses and considers the impacts of EPA's regulations on businesses, government entities, and the economy as a whole. Outreach and consultation are also priorities with a goal to make information on EPA's regulatory activities available to the public to improve transparency and encourage meaningful participation."
  },
  {
    value: '020:094',
    label: 'Research: Air, Climate and Energy (Science & Technology)',
    sublabel:
      'The Air, Climate and Energy (ACE) Research Program promotes innovative, sustainable, and integrated solutions to air pollution and climate change.'
  },
  {
    value: '020:095',
    label:
      'Research: Chemical Safety and Sustainability (Science & Technology)',
    sublabel:
      'This program uses an integrated research approach to develop innovative and cost-effective approaches and tools to better inform decisions to reduce harmful effects of chemicals on human health and the environment.'
  },
  {
    value: '020:096',
    label:
      'Research: Safe and Sustainable Water Resources (Science & Technology)',
    sublabel:
      'This program takes a systems approach to protecting human and aquatic ecosystem health and protecting and restoring watersheds for the sustainability of the nation’s water resources.'
  },
  {
    value: '020:097',
    label:
      'Research: Sustainable and Healthy Communities (Science & Technology, Superfund, Leaking Underground Storage Tanks, Oil Spill Response)',
    sublabel:
      'This program develops and conducts research leveraging the diverse capabilities of in-house scientists and engineers, and bridge traditional scientific disciplines. research plans will incorporate input from external stakeholders such as federal, state and local government agencies, nongovernmental organizations, industry, and communities affected by environmental problems.'
  },
  {
    value: '020:098',
    label: 'Science Advisory Board (Environmental Programs & Management)',
    sublabel:
      "This program along with two other statutorily mandated chartered Federal Advisory Committees, the Clean Air Scientific Advisory Committee and the Advisory Council on Clean Air Compliance Analysis, draw on a balanced range of non-EPA scientists and technical specialists from academia, communities, states, independent research institutions, and industry. Congress established EPA’s Science Advisory Board (SAB) in 1978 and gave it a broad mandate to advise the Administrator on a wide range of highly visible and important scientific matters to ensure that EPA's technical products are of the highest quality."
  },
  {
    value: '020:099',
    label:
      'Science Policy and Biotechnology (Environmental Programs & Management)',
    sublabel:
      "This program provides scientific and policy expertise, coordinates the EPA's intra-agency, interagency, and international efforts, and facilitates information sharing related to core science policy issues concerning pesticides, toxic chemicals, and products derived through biotechnology. This program also provides for independent, external scientific peer review through the Federal Insecticide, Fungicide, and Rodenticide Act Scientific Advisory Panel (FIFRA SAP), a federal advisory committee."
  },
  {
    value: '020:100',
    label: 'Small Business Ombudsman (Environmental Programs & Management)',
    sublabel:
      "This program serves as the Agency's leading advocate for small business regulatory issues and assists the EPA's program offices with analyzing and considering the impacts of its regulatory actions on small businesses."
  },
  {
    value: '020:101',
    label:
      'Small Minority Business Assistance (Environmental Programs & Management)',
    sublabel:
      "The Agency's Office of Small Business Programs' (OSBP) manages the agency's Small and Minority Business Assistance programs, which include the Direct Procurement, Disadvantaged Business Enterprise (DBE), and Minority Academic Institutions (MAI) programs. This program provides technical assistance to small businesses, headquarters, and regional office employees to ensure that small disadvantaged, women-owned, Historically Underutilized Business Zone (HUBZone), service-disabled veteran-owned small businesses (SDVOSBs), and MAIs receive a fair share of EPA's procurement dollars and grants, where applicable."
  },
  {
    value: '020:102',
    label:
      'State and Local Prevention and Preparedness (Environmental Programs & Management)',
    sublabel:
      "EPA's Risk Management program supports the State Emergency Response Commission (SERC) and the Local Emergency Planning Committee (LEPC) structure through tools, regulations and guidance. The program provides technical assistance to these entities to assess chemical risks, develop and revise emergency response plans, and make chemical information available to the public and assists in the performance of RMP facility inspections."
  },
  {
    value: '020:103',
    label:
      'Stratospheric Ozone: Domestic Programs (Environmental Programs & Management)',
    sublabel:
      'This program includes activities for regulatory programs to restore the ozone layer and voluntary programs to reduce public health risk.'
  },
  {
    value: '020:104',
    label:
      'Stratospheric Ozone: Multilateral Fund (Environmental Programs & Management)',
    sublabel:
      'This program includes the Multilateral Fund that promotes international compliance with the Montreal Protocol by financing the incremental cost of converting existing industries in developing countries to cost-effective ozone friendly technology.'
  },
  {
    value: '020:105',
    label:
      'Superfund: Emergency Response and Removal (Environmental Programs & Management, Superfund, Oil Spill Respond',
    sublabel:
      'This program works to ensure all immediate threats from releases and/or potential releases of hazardous substances are appropriately addressed at NPL and non-NPL responses for the protection of human health and the environment.'
  },
  {
    value: '020:106',
    label: 'Superfund: Enforcement (Superfund)',
    sublabel:
      'The Superfund Enforcement program emphasizes "Enforcement First" to ensure that sites for which there are viable responsible parties are cleaned up by those parties.'
  },
  {
    value: '020:107',
    label: 'Superfund: EPA Emergency Preparedness (Superfund)',
    sublabel:
      "This program works to ensure the readiness of EPA's preparedness and response personnel through planning, training, and exercises and coordination with the National Response Team and Regional Response Teams."
  },
  {
    value: '020:108',
    label:
      'Superfund: Federal Facilities (Environmental Programs & Management, Superfund, Oil Spill Response)',
    sublabel:
      'The Superfund Federal Facilities Enforcement program ensures, consistent with law, that sites with federal entities performing Comprehensive Environmental Response, Compensation, and Liability Act (CERCLA) responses and CERCLA sites with federal ownership are monitored and appropriate enforcement responses are pursued. After years of service and operation, some federal facilities contain environmental contamination, such as hazardous wastes, unexploded ordnance, radioactive wastes, or other toxic substances. To enable the cleanup and reuse of such sites, the Federal Facilities Enforcement program identifies and coordinates creative solutions that ensure the integrity of cleanups and protect both human health and the environment.'
  },
  {
    value: '020:109',
    label: 'Superfund: Remedial (Superfund)',
    sublabel:
      "This program works to protect the American public and the nation's resources by assessing and cleaning up contaminated sites in the United States. Cleanup activities include characterizing the degree and scope of contamination from releases to the environment, developing cleanup strategies, designing and constructing remedies, conducting long-term operation and the monitoring of certain remedies."
  },
  {
    value: '020:110',
    label: 'Superfund: Support to Other Federal Agencies (Superfund)',
    sublabel:
      'This program provides resources to support other federal agencies that contribute to the Superfund program by providing essential services in areas where EPA does not possess the required specialized expertise. This is part of the mature programs that are being eliminated. Funding for other Federal Agencies may be pursued for Superfund-related support services on an as-needed basis.'
  },
  {
    value: '020:111',
    label: 'Superfund: Federal Facilities Enforcement (Superfund',
    sublabel:
      'The Federal Facilities Enforcement Office as well as the Federal Facilities Regional Programs ensures that Federal agencies who own sites currently listed on the NPL have an Inter-Agency Agreement (IAG) in place to ensure clean up and compliance with Federal environmental statutes and regulations. IAGs are also referenced to as Federal Facilities Agreements (FFAs).'
  },
  {
    value: '020:112',
    label: 'Surface Water Protection (Environmental Programs & Management)',
    sublabel:
      'This program works to protect and restore the quality of surface waters (streams, rivers, lakes). It includes water quality standards and criteria, effluent guidelines, cooling water intake regulations, water quality assessment and monitoring, total maximum daily loads (TMDLs), National Pollutant Discharge Elimination System (NPDES), and nonpoint sources.'
  },
  {
    value: '020:113',
    label:
      'Toxic Substances: Chemical Risk Management (Environmental Programs & Management)',
    sublabel:
      'This programs supports national efforts aimed at mitigating risks of chemicals including polychlorinated biphenyls (PCBs), asbestos, mercury and dioxins, through reductions in use, safe removal, disposal or containment.'
  },
  {
    value: '020:114',
    label:
      'Toxic Substances: Chemical Risk Review and Reduction (Environmental Programs & Management)',
    sublabel:
      'This program works to ensure the safety of existing chemicals by obtaining needed data, assessing those data and taking regulatory and nonregulatory actions to eliminate or significantly reduce any unreasonable risk they may pose. It ensures the safety of new chemicals by reviewing and acting on new chemical notices submitted by industry, including PreManufacture Notices, to ensure that no unreasonable risk is posed when those chemicals are introduced to U.S. commerce.'
  },
  {
    value: '020:115',
    label:
      'Toxic Substances: Lead Risk Reducation Program (Environmental Programs & Management)',
    sublabel:
      'The program contributes to the goal of reducing children’s exposure to lead from lead-based paint through regulations, certification, and training programs and public outreach efforts.'
  },
  {
    value: '020:116',
    label: 'Trade and Governance (Environmental Programs & Management)',
    sublabel:
      'This program seeks to mitigate the potential domestic and global environmental effects from trade, and to prevent any potential conflicts with domestic environmental mandates. Growing U.S. global trade underscores the importance of addressing potential adverse environmental consequences.'
  },
  {
    value: '020:117',
    label: 'TRI / Right to Know (Environmental Programs & Management)',
    sublabel:
      'The program supports public access to environmental data from certain industrial facilities and tool development for the use of that data as well as scientific and economic support for the analysis and use of TRI program. Programs are designed to inform the public of toxic chemical releases and other waste management issues in their own neighborhoods.'
  },
  {
    value: '020:118',
    label: 'Tribal - Capacity Building (Environmental Programs & Management)',
    sublabel:
      'Under Federal environmental statutes, EPA has the responsibility for protecting human health and the environment in Indian country. EPA encourages building tribal capacity to administer their own environmental programs.'
  },
  {
    value: '020:119',
    label: 'US Mexico Border (Environmental Programs & Management)',
    sublabel:
      "This program carries out activities that address the environment and the health of over 14 million people along the 3,100 kilometer stretch of the U.S.-Mexico Border. The program is implemented in partnership with the ten (10) Border States, U.S. Tribal government, and the Government of Mexico with its corresponding states and tribes. It addresses the Agency's major themes of clean air, clean water, and clean land."
  },
  {
    value: '020:120',
    label:
      'Water Quality Research and Support Grants (Science & Technology, Environmental Programs & Management)',
    sublabel:
      'This program, designed to support the Clean Water Act (CWA), provides scientific information and tools to the Agency and others to help protect and restore the designated uses of water bodies that sustain human health and aquatic life.'
  },
  {
    value: '020:121',
    label: 'Wetlands (Environmental Programs & Management)',
    sublabel:
      'The Wetlands Program includes development and dissemination of guidance, information and scientific tools to improve management and public understanding of wetland programs.'
  },
  {
    value: '020:000',
    label: '(Primary Program Not Available)',
    sublabel:
      'The program associated with this data asset is not included in the Federal Program Inventory at this time.'
  }
]
